<template>
  <div>
    <vx-card title="รายละเอียดผลการดำเนินคดี" >
      <template #actions>
        <vx-tooltip text="บันทึกผลการดำเนินคดี">
          <router-link :to="{name: 'prosecution-transaction-add', params: {contractId, prosecutionId, prosecutionType} }">
            <vs-button class="-mt-0"   radius color="primary" icon-pack="feather" icon="icon-plus"  v-if="visibilityAdd"></vs-button>
          </router-link>
        </vx-tooltip>
      </template>
      <div class="w-full vx-coll-fixed-height" v-if="timelineData">
        <prosecution-timeline :timelineData="timelineData"></prosecution-timeline>
      </div>
    </vx-card>
  </div>
</template>

<script>
import prosecutionTimeline from '@/views/components/custom/ProsecutionTimeline.vue'
import {createNamespacedHelpers} from "vuex";
import {ICaseStatus} from "@/constants/interface";
const { mapState: mapProsecutionState} = createNamespacedHelpers('Prosecution')


export default {
  name: "ProsecutionTransaction",
  components: {
    prosecutionTimeline
  },
  computed:{
    ...mapProsecutionState(['prosecution', 'prosecutionDetails']),
    currentUser () {
      if(!this.$store.state.currentUser){
        return null
      }
      return {
        id: this.$store.state.currentUser.id,
        email: this.$store.state.currentUser.email,
        role: this.$store.state.currentUser.role
      }
    },
    isRoot(){
      if(!this.currentUser){
        return false
      }
      const { isRoot } = this.currentUser.role
      return isRoot
    },
    isLawyer(){
      if(!this.currentUser){
        return false
      }
      return this.currentUser.role.type === 'lawyer'
    },
    isLegalCounsel(){
      if(!this.currentUser){
        return false
      }
      return this.currentUser.role.type === 'legalCounsel'
    },
    contractId(){
      if(!this.prosecution.contract) return null;
      return this.prosecution.contract.id;
    },
    prosecutionId(){
      return this.prosecution.id;
    },
    prosecutionType(){
      return this.prosecution.prosecutionType;
    },
    timelineData() {
      const vm = this;
      const { prosecutionDetails } = vm;
      if(!prosecutionDetails) return null;
      return prosecutionDetails.map(prosecutionDetail => {
         return {
            contractId: vm.contractId,
            prosecutionId: vm.prosecutionId,
            id  : prosecutionDetail.id,
            seq: prosecutionDetail.seq,
            date: prosecutionDetail.date,
            caseStatus: prosecutionDetail.caseStatus,
            files: prosecutionDetail.files,
            remark: prosecutionDetail.remark,
            color : vm.$options.filters.caseStatusColor(prosecutionDetail.caseStatus),
            icon  : vm.$options.filters.caseStatusIcon(prosecutionDetail.caseStatus),
            title : prosecutionDetail.caseStatusName,
            desc  : prosecutionDetail.remark,
            createdAt  : prosecutionDetail.createdAt,
           createdAtLocal  : prosecutionDetail.createdAtLocal,
            createdBy  : prosecutionDetail.createdBy.fullName
          }
      })
    },
    visibilityAdd(){
      const { lawyerEmail } = this.prosecution;
      const isLawyerAssign = (this.isLawyer || this.isLegalCounsel) && lawyerEmail === this.currentUser.email;
      const caseStatuses = [ICaseStatus.draft, ICaseStatus.sendInformationContractToLawyer];
      return !caseStatuses.includes(this.prosecution.caseStatus) && (this.isRoot || isLawyerAssign);
    }
  },
}
</script>

<style scoped>
.vx-coll-fixed-height{
  display:block;
  width:100%;
  height:600px;
  overflow: auto;
}
</style>
